<dx-popup #popup [fullScreen]="false" [showTitle]="true" [dragEnabled]="true" [hideOnOutsideClick]="false"
    [showCloseButton]="true" [title]="'Zeiträume für Einstellungen ' + getBetragsArtText()" width="800" height="auto" maxHeight="700">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view #scrollView height="100%">

          <dx-data-grid
            class="perioden-datagrid"
            #periodenDataGrid
            [dataSource]="dataSource"
            (onToolbarPreparing)="onToolbarPreparing($event)"
						(onEditorPreparing)="onEditorPreparing($event)"
            (onRowDblClick)="onRowDblClick($event)"
						(onRowUpdating)="onRowUpdating($event)"
            [autoNavigateToFocusedRow]="true"
						[errorRowEnabled]="false"
            height="100%"
          >
            <dxo-header-filter [visible]="false"></dxo-header-filter>
            <dxo-editing  mode="form" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true" [useIcons]="true">
							<dxo-form #periodenForm [colCount]="3" [elementAttr]="{ class: 'form-intern' }">
                <dxi-item editorType="dxDateBox" dataField="von" format="dd.MM.yyyy" [label]="{ text: 'Von' }" [isRequired]="true">
									
                </dxi-item>
                <dxi-item editorType="dxDateBox" dataField="bis" [label]="{ text: 'Bis' }" [isRequired]="true">
                </dxi-item>
                <dxi-item editorType="dxTextBox" dataField="name" [label]="{ text: 'Bezeichnung' }" [isRequired]="true">
                </dxi-item>								
              </dxo-form>
						</dxo-editing>
            <dxo-selection selectAllMode="page" showCheckBoxesMode="none" mode="multiple"></dxo-selection>

            <dxi-column dataField="id" [visible]="false"></dxi-column>
            <dxi-column dataField="name" caption="Bezeichnung"></dxi-column>
            <dxi-column dataField="von" caption="Von" [width]="140" dataType="date" format="dd.MM.yyyy">
							<dxi-validation-rule type="custom" [validationCallback]="validateDates" message="Ungültiger Zeitraum: Das Anfangsdatum liegt nach dem Enddatum.">
    					</dxi-validation-rule>
						</dxi-column>
            <dxi-column dataField="bis" caption="Bis" [width]="140" dataType="date" format="dd.MM.yyyy">
							<dxi-validation-rule type="custom" [validationCallback]="validateDates" message="Ungültiger Zeitraum: Das Anfangsdatum liegt nach dem Enddatum.">
    					</dxi-validation-rule>
						</dxi-column>
          </dx-data-grid>            

        </dx-scroll-view>
    </div>
	<dxi-popup-toolbar-item widget="dxButton" location="after" toolbar="bottom"
		[options]="{ text: 'Schließen', type: 'default', stylingMode: 'contained', icon: 'remove', onClick: onClickClose }">
	</dxi-popup-toolbar-item>
</dx-popup>